// Team Planner shared constants — single source of truth for the six
// top-level views, the entity kinds used across polymorphic tables, and
// the scope selector ids.

export const PLANNER_VIEWS = [
  { id: "my-work", label: "My Work", icon: "LayoutDashboard" },
  { id: "rocks", label: "Rocks", icon: "Target" },
  { id: "milestones", label: "Milestones", icon: "Flag" },
  { id: "todos", label: "To-dos", icon: "CheckSquare" },
  { id: "opportunities", label: "Opportunities", icon: "Lightbulb" },
  { id: "health", label: "Health", icon: "Activity" },
  { id: "teams", label: "Teams", icon: "Users" },
] as const;

export type PlannerViewId = (typeof PLANNER_VIEWS)[number]["id"];

export const PLANNER_SCOPES = [
  { id: "mine", label: "Mine" },
  { id: "my-teams", label: "My teams" },
  { id: "all", label: "All" },
] as const;
export type PlannerScopeId = (typeof PLANNER_SCOPES)[number]["id"];

export const PLANNER_ITEM_KINDS = [
  "rock",
  "milestone",
  "todo",
  "subtask",
  "issue",
] as const;
export type PlannerItemKind = (typeof PLANNER_ITEM_KINDS)[number];

export const PLANNER_SAVED_FILTERS_STORAGE_KEY =
  "bsp.team-planner.savedFilters.v1";
